import { AxiosResponse } from 'axios';
import { wlBalanceExport, wlBalanceList } from '@/api/wlBalance';
import { AppError } from '@/errors/appError';
import { baseListExportService, baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types/service';
import { IWlBalanceApiListResponse, IWlBalanceFilters } from '@/types/wlBalance';

export const wlBalanceService = {
    async list(params: IListParams<IWlBalanceFilters>): Promise<AxiosResponse<IWlBalanceApiListResponse>> {
        try {
            const response = await baseListService<IWlBalanceApiListResponse>(wlBalanceList, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('WL Balance API Error:', e);
            throw new AppError(`Unable to load WL balance list, request error`, { cause: e });
        }
    },

    async export(params: IListParams<IWlBalanceFilters>): Promise<AxiosResponse<Blob>> {
        try {
            const response = await baseListExportService(wlBalanceExport, params);
            return response;
        } catch (e) {
            console.error('WL Balance Export API Error:', e);
            throw new AppError(`Unable to export WL balance, request error`, { cause: e });
        }
    },
};
